import { render, staticRenderFns } from "./SwapContact.vue?vue&type=template&id=57829025"
import script from "./SwapContact.vue?vue&type=script&lang=js"
export * from "./SwapContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports